import { render, staticRenderFns } from "./VatValue.vue?vue&type=template&id=42e76924&"
import script from "./VatValue.vue?vue&type=script&lang=js&"
export * from "./VatValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports